const INTENDED_ROUTE_KEY = 'cringe-quest:intended-route';
const DEFAULT_AUTHENTICATED_ROUTE = '/chat';

function buildPath(locationLike) {
  if (!locationLike) {
    return '';
  }

  if (typeof locationLike === 'string') {
    return locationLike;
  }

  return `${locationLike.pathname || ''}${locationLike.search || ''}${locationLike.hash || ''}`;
}

export function rememberIntendedRoute(locationLike) {
  const path = buildPath(locationLike);

  if (!path || path.startsWith('/auth') || path.startsWith('/login')) {
    return;
  }

  sessionStorage.setItem(INTENDED_ROUTE_KEY, path);
}

export function consumeIntendedRoute() {
  const storedRoute = sessionStorage.getItem(INTENDED_ROUTE_KEY);
  sessionStorage.removeItem(INTENDED_ROUTE_KEY);
  return storedRoute || DEFAULT_AUTHENTICATED_ROUTE;
}

export function resolvePostAuthRoute(locationState) {
  const from = buildPath(locationState?.from);

  if (from && !from.startsWith('/auth') && !from.startsWith('/login')) {
    return from;
  }

  return consumeIntendedRoute();
}

export function getDefaultAuthenticatedRoute() {
  return DEFAULT_AUTHENTICATED_ROUTE;
}
